export const environment = {
  apiUrl: 'https://preproduccion.duacode.org/pilgrim/chatbot-ia-node/api/v1',
  wsUrl: 'https://preproduccion.duacode.org',
  socketPath: '/pilgrim/chatbot-ia-node/socket.io',
  botName: 'UltreIA',
  botStatusLabel: 'Online',
  welcomeMessage:
    'Hola, soy UltreIA, el chatbot de Pilgrim. Puedo ayudarte a resolver dudas sobre el Camino y orientarte en tu viaje.',
};
